import { useContext, useState } from 'react';

import { CropDragContext } from './CropDragProvider';

import { CellDragEnteredContext } from './CellDragEnteredProvider';

function CropDropLayer({cell,onCropDrop,cropIdsBeingDragged,setCropIdsBeingDragged}){
  const { cellDragEntered, setCellDragEntered } = useContext(CellDragEnteredContext);

  const onDrop = e => {

    //e.stopImmediatePropagation();
    //e.stopPropagation();

    console.log("On drop..." + JSON.stringify(cropIdsBeingDragged));

    onCropDrop([cell.y,cell.x]);
    //console.log("RESETTING CELL DRAG ENTERED");
    setCellDragEntered([-1,-1]);
    setCropIdsBeingDragged([]);
  }
  const onClick = e => {
    onDrop(e);
  }

  const isSelected = cellDragEntered && (
    cellDragEntered[0] === cell.y && cellDragEntered[1] === cell.x
  );

  const className = "absolute-cover";




  return (
    <div 
      onMouseEnter={e => {
        setCellDragEntered([
          cell.y,cell.x
        ])
      }}
      onMouseDown={(e) => console.log("Drop layer down.")}
      onMouseUp={onDrop}
      onClick={onClick}
      style={{
      }}
      class={className}>
      {false && JSON.stringify(cropIdsBeingDragged.map(x => x.annotationId))}
      {isSelected && <div class="selected-item-cover"/>}

    </div>
  )

}

export default function CropDropLayerWrapper({cell}){


  const cropDragContext = useContext(CropDragContext);

  let { cropIdsBeingDragged, setCropIdsBeingDragged, onCropDrop } = cropDragContext || {};




  if( !cropIdsBeingDragged || cropIdsBeingDragged.length === 0 ){
    //console.log("CropDropLayer --> null");
    return null;
  }

  return <CropDropLayer {...{cell,onCropDrop,cropIdsBeingDragged,setCropIdsBeingDragged}}/>

  

  
}
